import { createReducer } from '@reduxjs/toolkit';
import InitialState from './initial-state';
import { codeLookup } from '../actions/code-lookup';
import * as UIActions from '../actions/ui';
import { jumpContext } from '../actions/contexts.action';
export const reducer = createReducer(InitialState.codeLookup, (builder)=>{
    builder.addCase(UIActions.logout.type, ()=>({
            ...InitialState.codeLookup
        }));
    builder.addCase(jumpContext.pending.type, ()=>({
            ...InitialState.codeLookup
        }));
    builder.addCase(codeLookup.fulfilled, (state, action)=>({
            ...state,
            searchResult: {
                content: action.payload.content
            },
            searchRequest: {
                searchTerm: action.meta.arg.searchTerm,
                codeType: action.meta.arg.codeType,
                effectiveDate: action.meta.arg.effectiveDate
            }
        }));
});
export default reducer;
